$(function () {
    const manageCardToggle = function () {
        let toggleCardActive = 0;
        const $body = $('body');
        const $cardBtn = $('#show-card');
        const $cardToggleBox = $('#cardToggleBox');
        document.addEventListener('touchstart', handleTouchStart, false);
        document.addEventListener('touchmove', handleTouchMove, false);

        let yDown = null;

        function getTouches(evt) {
            return evt.touches ||
                evt.originalEvent.touches;
        }

        function handleTouchStart(evt) {
            const firstTouch = getTouches(evt)[0];
            yDown = firstTouch.clientY;
        };

        function handleTouchMove(evt) {
            if (!yDown) {
                return;
            }

            var yUp = evt.touches[0].clientY;
            var yDiff = yDown - yUp;

            if (yDiff > 0) {

            } else {
                closeCardToggle();
            }

            yDown = null;
        };

        let manageFilterOuterClick = function () {
            let cardBtn = $cardBtn[0];
            let cardToggleBox = $cardToggleBox[0];
            $(document).on('click', function (event) {
                if (toggleCardActive && cardBtn !== event.target && !cardBtn.contains(event.target) && cardToggleBox !== event.target && !cardToggleBox.contains(event.target)) {
                    closeCardToggle();
                    return false;
                }
            });
        }

        const openCardToggle = function () {
            $cardBtn.attr('aria-expanded', 'true');
            $cardToggleBox.addClass('activeBox');
            toggleCardActive = 1;
            $cardToggleBox.append('<span class="nav-overlay" />');
            manageFilterOuterClick();
            $body.addClass('overflow-hidden');

            $('.nav-overlay').on('click', function () {
                closeCardToggle();
            });
        }

        const closeCardToggle = function () {
            $cardBtn.attr('aria-expanded', 'false');
            $cardToggleBox.removeClass('activeBox');
            toggleCardActive = 0;
            $('.nav-overlay').remove();
            $body.removeClass('overflow-hidden');
        }

        $cardBtn.on('click', function () {
            if (toggleCardActive) {
                closeCardToggle();
            } else {
                openCardToggle();
            }
        });
        $('.close-card-box').on('click', function () {
            closeCardToggle();
        });
    }

    manageCardToggle();
});